export default __webpack_public_path__ + "static/media/email.502844a0.svg";